// Utilitário para formatar duração em minutos como horas e minutos
// Regras:
// - Se total < 60: "X min"
// - Se total >= 60 e múltiplo de 60: "H h"
// - Caso contrário: "H h M min"
export function formatDurationMinutes(totalMinutes: number | null | undefined): string {
  if (totalMinutes == null || isNaN(totalMinutes as any)) return "-";
  const m = Math.max(0, Math.floor(totalMinutes as number));
  if (m < 60) return `${m} min`;
  const h = Math.floor(m / 60);
  const rem = m % 60;
  if (rem === 0) return `${h} h`;
  return `${h} h ${rem} min`;
}

// Versão compacta opcional, caso seja útil futuramente
export function formatDurationCompact(totalMinutes: number | null | undefined): string {
  if (totalMinutes == null || isNaN(totalMinutes as any)) return "-";
  const m = Math.max(0, Math.floor(totalMinutes as number));
  if (m < 60) return `${m}m`;
  const h = Math.floor(m / 60);
  const rem = m % 60;
  if (rem === 0) return `${h}h`;
  return `${h}h ${rem}m`;
}
